export default __webpack_public_path__ + "static/media/t24.min.92882809.png";